import React from 'react';
import { useEvent } from '../../../data/hooks/eventHooks';
import { useI18n } from '../../../data/hooks/i18nHooks';
import { useEventLocations } from '../../../data/hooks/locationHooks';
import ActionButton from '../../elements/ActionButton/ActionButton';

const MeetingLocationsBlocklink = (props) => {
    const { eventId, href } = props,
        event = useEvent(eventId),
        locations = useEventLocations(eventId),
        i18n = useI18n();

    if (!locations.length) return null;
    if (event.settings.disable_meetings) return null;

    return (
        <ActionButton
            className="margins"
            href={href || ['/events', event.id, 'locations'].join('/')}
            secondary
            next
        >
            {i18n['label.metting']}
        </ActionButton>
    );
};

export default MeetingLocationsBlocklink;
